module.exports = __webpack_public_path__ + "static/fonts/weathericons-regular-webfont.4b65876.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/weather-icons/font/weathericons-regular-webfont.eot
// module id = MOR2
// module chunks = 1